import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c(VAppBar,{attrs:{"dark":"","app":"","color":"primary"}},[_c('img',{staticClass:"header-logo ml-2",attrs:{"src":require("../../assets/logo-branca.png"),"alt":"Logo da Proxpect"}}),_c(VSpacer)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }